module.exports = __webpack_public_path__ + "static/media/icon_radio_sel.dd7b95cd.svg";